import { env } from '@/constants';
import { NeonHttpUtils, type NeonFilterItem } from '@art-basel/artbasel-lib-neon';
import { toTitleCase } from './stringUtils';

// TODO: consolidate this with router-utils & HttpUtils
export const urlWithRedirect = (url: string, target?: string | null) => {
  const [path, params] = url.split('?');
  const searchParams = new URLSearchParams();

  if (params) {
    params.split('&').forEach((param) => {
      const [k, v] = param.split('=');
      searchParams.append(k, v);
    });
  }

  if (target) {
    searchParams.set('redirectTo', target);
  }

  return path + (Array.from(searchParams).length !== 0 ? `?${searchParams.toString()}` : '');
};

// TODO: move to Neon HttpUtils
export const urlWithUtm = (
  url: string,
  { source, medium, campaign }: { source?: string; medium?: string; campaign?: string },
): string => {
  return NeonHttpUtils.urlWithQueryParams(url, {
    utm_source: source,
    utm_medium: medium,
    utm_campaign: campaign,
  });
};

export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

export const arcualDomain = () => {
  let label = '';
  const environment = env.VITE_AZURE_ENV === 'production' ? '.' : `.${env.VITE_AZURE_ENV}.`;

  label += `${environment}artbasel.app`;

  return label;
};

export const isValidURLByConstructor = (url?: string): boolean => {
  try {
    return !!new URL(url || '');
  } catch {
    return false;
  }
};

// Parse query value as string (Single Option)
export const parseStringQueryValue = (value: string | string[] | null | undefined): string => {
  if (Array.isArray(value)) return value[0] ?? '';
  return value ?? '';
};

// Parse query value as array of strings (Multiple Options)
export const parseArrayQueryValues = (value: string | string[] | null | undefined): string[] => {
  if (!value) {
    return [];
  }

  const rawValues = Array.isArray(value) ? value : [value];

  return rawValues
    .flatMap((entry) => entry.split(','))
    .map((entry) => entry.trim());
};

// Convert query into valid NeonFilterItem array
export const mapQueryValuesToSelectedOptions = (values: string[], unknownLabel: string = 'Unknown'): (NeonFilterItem & {value: string})[] => {
  return values.map((value) => ({
    value,
    label: value.trim() ? toTitleCase(value) : unknownLabel,
    count: 0,
    selected: true,
  }));
};